/**
 * Converted from flindersonline-frontend component
 * GSAP and Swiper are available as global variables
 * Original imports have been removed and replaced with global access
 */

// src/main/resources/site/js/components/featureTileCarousel/featureTileCarousel.js

// Import Swiper and required modules
// Swiper is available globally
// Swiper modules are available globally

// Import Swiper styles
// Swiper CSS is included globally
// Swiper CSS is included globally
// Swiper CSS is included globally

(function() {
  'use strict';

  let swipers = []; // Keep track of all initialized swipers

  /**
   * Initialize Feature Tile Carousel
   */
  function initFeatureTileCarousel() {
    const carousels = document.querySelectorAll('.cmp-flindersonline-featuretile');
    
    if (carousels.length === 0) return;
    
    // Store active tab for each card before destroying swipers
    document.querySelectorAll('.featuretile-card').forEach(card => {
      const activeTabBtn = card.querySelector('.featuretile-switch-tab .pill.active');
      if (activeTabBtn) {
        card.setAttribute('data-active-tab', activeTabBtn.getAttribute('data-tab'));
      }
    });
    
    // Destroy any existing swipers before reinitializing
    swipers.forEach(swiper => {
      if (swiper && swiper.destroy) {
        swiper.destroy(true, true);
      }
    });
    swipers = [];
    
    carousels.forEach(function(carousel) {
      initSingleCarousel(carousel);
    });

    // Restore active tab for each card after re-initialization
    document.querySelectorAll('.featuretile-card').forEach(card => {
      const activeTab = card.getAttribute('data-active-tab') || 'tab1';
      // Restore active class on tab buttons
      const pillButtons = card.querySelectorAll('.featuretile-switch-tab .pill');
      pillButtons.forEach(btn => {
        if (btn.getAttribute('data-tab') === activeTab) {
          btn.classList.add('active');
        } else {
          btn.classList.remove('active');
        }
      });
      // Restore active class and opacity on tab content
      const tabContents = card.querySelectorAll('.tab-content');
      tabContents.forEach(content => {
        if (content.getAttribute('data-tab-content') === activeTab) {
          content.classList.add('active');
          content.style.opacity = '1';
        } else {
          content.classList.remove('active');
          content.style.opacity = '0';
        }
      });
    });
  }

  /**
   * Initialize a single carousel instance
   * @param {HTMLElement} carousel - The carousel container element
   */
  function initSingleCarousel(carousel) {
    const swiperContainer = carousel.querySelector('.swiper-container');
    const prevButton = carousel.querySelector('.featuretile-prev');
    const nextButton = carousel.querySelector('.featuretile-next');
    const slides = carousel.querySelectorAll('.swiper-slide');
    
    if (!swiperContainer || slides.length === 0) return;
    
    // Store current index in a data attribute if Swiper already exists
    let initialSlide = 0;
    if (swiperContainer.swiper) {
      initialSlide = swiperContainer.swiper.activeIndex;
      swiperContainer.setAttribute('data-initial-slide', initialSlide);
      swiperContainer.swiper.destroy(true, true);
    } else if (swiperContainer.hasAttribute('data-initial-slide')) {
      initialSlide = parseInt(swiperContainer.getAttribute('data-initial-slide'), 10) || 0;
    }
    
    // Get the current viewport width
    const viewportWidth = window.innerWidth;
    
    // Initialize Swiper with responsive settings
    const featureTileSwiper = new Swiper(swiperContainer, {
      slidesPerView: 1,
      centeredSlides: false,
      spaceBetween: 10,
      watchOverflow: true,
      grabCursor: true,
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton
      },
      initialSlide: initialSlide, // <-- preserve current slide
      breakpoints: {
        // Mobile view - with requested slide width
        320: {
          centeredSlides: true,
          slidesPerView: 1,
          spaceBetween: 24,
          width: 303 // Fixed width for mobile slides as requested
        },
        // Tablet view
        768: {
          centeredSlides: true,
          slidesPerView: 1,
          spaceBetween: 24,
          width: 440 // Keep the 303px width until 1024px
        },
        // Desktop view
        1024: {
          slidesPerView: 1,
          spaceBetween: 24,
          width: null // Reset to auto for desktop
        }
      }
    });
    
    // Add the swiper instance to our tracking array
    swipers.push(featureTileSwiper);
    
    // Hide navigation if only one slide
    const navigation = carousel.querySelector('.featuretile-navigation');
    if (slides.length <= 1 && navigation) {
      navigation.style.display = 'none';
    }
    
    // Initialize tab switching
    initTabSwitching(carousel);
  }

  /**
   * Initialize tab switching functionality
   * @param {HTMLElement} carousel - The carousel container element
   */
  function initTabSwitching(carousel) {
    const tabButtons = carousel.querySelectorAll('.featuretile-switch-tab .pill');
    
    tabButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        const tabName = this.getAttribute('data-tab');
        const card = this.closest('.featuretile-card');
        
        // Toggle active state on buttons
        const pillButtons = card.querySelectorAll('.featuretile-switch-tab .pill');
        pillButtons.forEach(function(btn) {
          btn.classList.remove('active');
        });
        this.classList.add('active');
        
        // Hide all tab content
        const tabContents = card.querySelectorAll('.tab-content');
        tabContents.forEach(function(content) {
          content.classList.remove('active');
          content.style.opacity = '0';
        });
        
        // Show selected tab content with fade animation
        const selectedContent = card.querySelector(`[data-tab-content="${tabName}"]`);
        if (selectedContent) {
          selectedContent.classList.add('active');
          requestAnimationFrame(() => {
            setTimeout(() => {
              selectedContent.style.opacity = '1';
            }, 10);
          });
        }
      });
    });
  }

  // Sync active tab state between mobile/desktop headers and tab content on resize
  function syncActiveTabsOnResize() {
    document.querySelectorAll('.featuretile-card').forEach(card => {
      // Find the active tab in either header
      const activeBtn = card.querySelector('.featuretile-switch-tab .pill.active');
      const activeTab = activeBtn ? activeBtn.getAttribute('data-tab') : 'tab1';

      // Sync active state for all tab buttons in this card
      card.querySelectorAll('.featuretile-switch-tab .pill').forEach(btn => {
        if (btn.getAttribute('data-tab') === activeTab) {
          btn.classList.add('active');
        } else {
          btn.classList.remove('active');
        }
      });

      // Sync tab content
      card.querySelectorAll('.tab-content').forEach(content => {
        if (content.getAttribute('data-tab-content') === activeTab) {
          content.classList.add('active');
          content.style.opacity = '1';
        } else {
          content.classList.remove('active');
          content.style.opacity = '0';
        }
      });
    });
  }

  // Debounce function to limit the rate at which a function can fire
  function debounce(func, wait) {
    let timeout;
    return function() {
      const context = this;
      const args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        func.apply(context, args);
      }, wait);
    };
  }

  // Attach debounced resize event listener to sync active tabs
  window.addEventListener('resize', debounce(syncActiveTabsOnResize, 100));

  // Execute when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initFeatureTileCarousel();
    //   setupResizeObserver();
    });
  } else {
    // If already loaded, run immediately
    requestAnimationFrame(function() {
      initFeatureTileCarousel();
    //   setupResizeObserver();
    });
  }
})();